import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { projectsApi } from '../../../utils';
import useClickOutside from '../../../hooks/useClickOutside';
import DynamicMessage from './Popups/DynamicMessage/DynamicMessage';
import PlayIcon from '../assests/playIcon.png'
import DisabledIcon from '../assests/disabledIcon.png'
import CopyIcon from '../assests/copy.png'
import DeleteIcon from '../assests/delete.png'
import SendIcon from '../assests/send-icon.png'
import ChangeIcon from '../assests/change.png'
import editIcon from '../assests/edit.png'
import classes from './Project.module.css';
import { throwApiError } from "../store/error-handling-actions";
import SendLink from './SendLink';
import { onKeyDown } from '../service';
import restoreBaseProject from "../assests/restore-base-project.png"
import SuccessProjectPopup from './Popups/SuccessProjectPopup/SuccessProjectPopup';
import { DynamicMessageTypeEnum } from '../models/DynamicMessageTypeEnum';
import { ObjectTypeEnumText } from '../models/ObjectTypeEnum';

const Project = ({ project, descriptionDate, openProject, selectProject, canDelete, actionCallback, canChange, currentIdToEdit, handleChangeCurrentIdToEdit, setCurrentIdToEdit, editProjectName, changeProjectFunc, noEditName, showFunc, oldProject, shareBtn, canSend, onlyView, saveProjectCallback, canRestore, isDisabled }) => {

    const texts = useSelector(state => state.translate.texts);
    const studyGroup = useSelector(state => state.topics.studyGroup);
    const uiData = useSelector((state) => state.general.uiData);
    const [message, setMessage] = useState(null)
    const [messagePopup, setMessagePopup] = useState()
    const [ideIcon, setIdeIcon] = useState()
    const ComponentShareBtn = shareBtn
    const dispatch = useDispatch();


    useEffect(() => {
        if (uiData) {
            setIdeIcon(uiData.ides[project.ide.id - 1]?.ProjectImage)
        }
    }, [uiData])

    function copyProject() {
        const opts = {
            id: project.id,
            refObjectType: ObjectTypeEnumText.StudyGroup,
            refObjectId: studyGroup.id
        }
        projectsApi.projectsDuplicatePost(opts, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.projectsDuplicateError, error: error, statusCode: response?.statusCode, message: "projectsDuplicatePost " + error.message, level: 2, component: "Project", line: 32 }))
            }
            else {
                setMessage(
                    <SuccessProjectPopup
                        close={() => setMessage(false)}
                        color="#CCF0F0"
                        type="duplicate"
                        title={texts.duplicatePopupTile}
                    >
                        <div className={classes.submissionPopupContent}>{texts.SuccessDuplicatePopup}</div>
                        <div className={classes.DProjectImg}>
                            <div className={classes.ThumbnailImage} style={{ backgroundImage: `url(${project.thumbnail})` }}></div>
                        </div>
                        <div className={classes.Description}>{project.name}</div>
                    </SuccessProjectPopup>)
                if (actionCallback)
                    actionCallback()
            }
        })
    }

    function deleteProject() {
        setMessagePopup(<DynamicMessage
            type={DynamicMessageTypeEnum.Warn}
            content={texts.MessageContentDeleteProjectWarn}
            cancelFunc={() => setMessagePopup(false)}
            confirmFunc={deleteProjectcConfirm} />)
    }

    function restorePrject() {
        setMessagePopup(<DynamicMessage
            type={DynamicMessageTypeEnum.Warn}
            content={texts.MessageContentRestoreProjectWarn}
            cancelFunc={() => setMessagePopup(false)}
            confirmFunc={restoreProjectConfirm} />)
    }

    function deleteProjectcConfirm() {
        projectsApi.projectsDeleteIdPost(project.id, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessageContentDeleteProjectStatus, error: error, statusCode: response?.statusCode, message: "projectsDeleteIdPost " + error.message, level: 2, component: "Project", line: 60 }))
            } else {
                if (actionCallback)
                    actionCallback()
            }
        })
        setMessagePopup(false)
    }

    function restoreProjectConfirm() {
        let myData = {
            id: project.id,
            studyGroupId: studyGroup?.id
        }
        projectsApi.projectsRestorePost({ projectRestoreInput: myData }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessageContentRestoreProjectStatus, error: error, statusCode: response?.statusCode, message: "projectsDeleteIdPost " + error.message, level: 2, component: "Project", line: 60 }))

            }
            else {
                if (actionCallback)
                    actionCallback()
            }
        })
        setMessagePopup(false)
    }

    const editRef = useRef(null);
    useClickOutside(editRef, () => {
        setCurrentIdToEdit && setCurrentIdToEdit(null)
    });

    const handleOpenProject = () => {
        if (!window.location.pathname.includes('/project/')) {
            openProject && openProject()
        }
    }

    const sendLinkFun = () => {
        setMessage(<SendLink setMessage={setMessage} project={project} />);
    }

    return (
        <div className={`${classes.Project} ${selectProject && classes.Clickable}`} key={project.id} onClick={(e) => selectProject && selectProject(e.detail == 2)} tabIndex="0" role="button">
            {uiData && message}
            {messagePopup}
            <div className={`${classes.ProjectImg} ${!oldProject && classes.Img}`}>
                {ideIcon && <img className={classes.IdeIcon} src={ideIcon} alt="ideIcon" />}
                {/* IF popup (oldprojects or projects popoup in assessment -) don't show PlayIcon. ELSE IF assessment - show PlayIcon. ELSE IF drafts - don't show PlayIcon*/}
                {(!isDisabled && (!oldProject || noEditName)) && <img className={classes.PlayIcon} src={PlayIcon} alt="PlayIcon" onClick={handleOpenProject} style={{ display: "flex" }} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, handleOpenProject)} />}
                {(isDisabled && (!oldProject || noEditName)) && <img className={classes.DisabledIcon} src={DisabledIcon} alt="DisabledIcon" style={{ display: "flex" }} tabIndex="0" role="button" />}
                {showFunc && <div className={classes.IconsHoverContainer} tabIndex="0" role="button">

                    {canSend && <>
                        <img className={classes.Icon} src={SendIcon} alt="SendIcon" onClick={sendLinkFun} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, sendLinkFun)} />
                        <div className={`${classes.Tooltip} ${classes.Send}`}>{texts.send}</div>
                    </>}

                    {ComponentShareBtn && <ComponentShareBtn project={project} setMessage={setMessage} saveProjectCallback={saveProjectCallback} />}

                    {!onlyView && <>
                        <img className={classes.Icon} src={CopyIcon} alt="CopyIcon" onClick={copyProject} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, copyProject)} />
                        <div className={`${classes.Tooltip} ${classes.Copy}`} style={{ left: !canChange && !canDelete && "65px" }}>{texts.copy}</div>
                    </>}

                    {canDelete && <>
                        <img className={classes.Icon} src={DeleteIcon} alt="DeleteIcon" onClick={deleteProject} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, deleteProject)} />
                        <div className={`${classes.Tooltip} ${classes.Delete}`}>{texts.delete}</div>
                    </>}

                    {canChange && <>
                        <img className={classes.Icon} src={ChangeIcon} alt="ChangeIcon" onClick={changeProjectFunc} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, changeProjectFunc)} />
                        <div className={`${classes.Tooltip} ${classes.Change}`}>{texts.change}</div>
                    </>}
                    {canRestore && <>
                        <img className={classes.Icon} src={restoreBaseProject} alt="restoreBaseProject" onClick={restorePrject} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, changeProjectFunc)} />
                        <div className={`${classes.Tooltip} ${classes.RestoreBaseProject}`}>{texts.restoreBaseProject}</div>
                    </>}
                </div>}
                <img></img>
                {uiData && <div className={classes.ThumbnailImage}
                    style={{
                        backgroundImage: project.thumbnail && project.thumbnail !== "" ?
                            `url(${project.thumbnail})`
                            :
                            `url(${uiData.ides[project.ide.id - 1]?.defaultThumbnail})`
                    }}>
                </div>}
            </div>
            <div className={classes.ProjectDetails}>
                <div>
                    {project.id === currentIdToEdit ?
                        <input ref={editRef}
                            type='text'
                            defaultValue={project.name}
                            // placeholder={project.name}
                            name="newProjectName"
                            className={classes.ProjectNameInput}
                            onBlur={(e) => editProjectName(project.id, e.target.value)}
                        ></input>
                        :
                        <div className={`${classes.ProjectName} ${noEditName && classes.NoEdit} ${oldProject && classes.OldProjectName}`}>{project.name}</div>
                    }
                    <div className={`${classes.ProjectDate} ${noEditName && classes.NoEdit} ${oldProject && classes.OldProject}`}>{descriptionDate}</div>
                </div>
                {handleChangeCurrentIdToEdit && <img className={`${classes.Icon} ${classes.EditIcon}`} src={editIcon} alt="EditIcon" onClick={(e) => handleChangeCurrentIdToEdit(e, project)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleChangeCurrentIdToEdit(e, project))} />}
            </div>
        </div>
    )
}

export default Project;